/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { EntitlementType } from './entitlement-type';
import { LocalizedFieldBody } from './localized-field-body';
import { RecommendationContentType } from './recommendation-content-type';
import { RecommendationsType } from './recommendations-type';
import { RecommendationsUIModuleContentTreatment } from './recommendations-uimodule-content-treatment';
import { TargetPlatform } from './target-platform';
import { UiModuleExperimentGroup } from './ui-module-experiment-group';

/**
 * 
 * @export
 * @interface RecommendationsUiModuleBody
 */
export interface RecommendationsUiModuleBody {
    /**
     * 
     * @type {string}
     * @memberof RecommendationsUiModuleBody
     */
    moduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof RecommendationsUiModuleBody
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof RecommendationsUiModuleBody
     */
    hash?: string;
    /**
     * 
     * @type {string}
     * @memberof RecommendationsUiModuleBody
     */
    moduleType: RecommendationsUiModuleBodyModuleTypeEnum;
    /**
     * 
     * @type {Array<TargetPlatform>}
     * @memberof RecommendationsUiModuleBody
     */
    targetPlatform?: Array<TargetPlatform>;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof RecommendationsUiModuleBody
     */
    caption?: LocalizedFieldBody;
    /**
     * 
     * @type {Array<EntitlementType>}
     * @memberof RecommendationsUiModuleBody
     */
    entitlements?: Array<EntitlementType>;
    /**
     * 
     * @type {Array<UiModuleExperimentGroup>}
     * @memberof RecommendationsUiModuleBody
     */
    experiments?: Array<UiModuleExperimentGroup> | null;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof RecommendationsUiModuleBody
     */
    title: LocalizedFieldBody;
    /**
     * 
     * @type {RecommendationsUIModuleContentTreatment}
     * @memberof RecommendationsUiModuleBody
     */
    contentTreatment: RecommendationsUIModuleContentTreatment;
    /**
     * 
     * @type {RecommendationsType}
     * @memberof RecommendationsUiModuleBody
     */
    recommendationsType?: RecommendationsType;
    /**
     * 
     * @type {Array<RecommendationContentType>}
     * @memberof RecommendationsUiModuleBody
     */
    contentTypes: Array<RecommendationContentType>;
    /**
     * 
     * @type {string}
     * @memberof RecommendationsUiModuleBody
     */
    collectionId?: string;
    /**
     * 
     * @type {number}
     * @memberof RecommendationsUiModuleBody
     */
    premiumContentPercentage?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum RecommendationsUiModuleBodyModuleTypeEnum {
    RECOMMENDATIONS = 'RECOMMENDATIONS'
}



